import { addDoc, collection, deleteDoc, doc, getDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import {
    ADD_ARTIST,
    ADD_ARTIST_FAILURE,
    ADD_ARTIST_SUCCESS,
    DELETE_ARTIST,
    DELETE_ARTIST_FAILURE,
    DELETE_ARTIST_SUCCESS,
    DELETE_PICTURE,
    DELETE_PICTURE_FAILURE,
    DELETE_PICTURE_SUCCESS,
    EDIT_ARTIST,
    EDIT_ARTIST_FAILURE,
    EDIT_ARTIST_SUCCESS,
    FETCH_ARTIST,
    FETCH_ARTIST_FAILURE,
    FETCH_ARTIST_SUCCESS,
    FETCH_ARTISTS,
    FETCH_ARTISTS_FAILURE,
    FETCH_ARTISTS_SUCCESS
} from "./Types";
import { db, storage } from "../App";
import { message } from "antd";
import { deleteObject, ref } from "firebase/storage";



export const addArtist = (artistData) => {
    return async (dispatch) => {
        dispatch({ type: ADD_ARTIST });

        try {
            const artistRef = doc(db, "artists", artistData.username.toLowerCase()); // Use username as the doc name
            const artistSnap = await getDoc(artistRef);

            if (artistSnap.exists()) {
                message.warning("Artist with this username already exists!");
                dispatch({ type: ADD_ARTIST_FAILURE, payload: "Artist already exists" });
                return;
            }

            const newArtist = {
                ...artistData,
                time: Date.now(), // Add timestamp
            };
            // console.log(newArtist)
            await setDoc(artistRef, newArtist); // Use setDoc to create the document

            dispatch({
                type: ADD_ARTIST_SUCCESS,
                payload: { id: artistData.username, ...newArtist },
            });

            message.success("Artist added successfully!");
        } catch (error) {
            dispatch({
                type: ADD_ARTIST_FAILURE,
                payload: error.message,
            });

            // console.log(error.message);
            message.error("Failed to add artist!");
        }
    };
};



export const editArtist = (artistId, artistData) => {
    return async (dispatch) => {
        dispatch({ type: EDIT_ARTIST });

        try {
            const artistRef = doc(db, "artists", artistId.toLowerCase());
            const updatedData = {
                ...artistData,
                lastEdited: Date.now(), // Update timestamp
            };

            await updateDoc(artistRef, updatedData);

            dispatch({
                type: EDIT_ARTIST_SUCCESS,
                payload: { id: artistId, ...updatedData },
            });

            message.success('Artist updated successfully!');

        } catch (error) {
            dispatch({
                type: EDIT_ARTIST_FAILURE,
                payload: error.message,
            });
            message.error('Failed to update artist!');

        }
    };
};



export const fetchArtists = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_ARTISTS });

        try {
            const unsubscribe = onSnapshot(collection(db, "artists"), (snapshot) => {
                const artists = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                dispatch({
                    type: FETCH_ARTISTS_SUCCESS,
                    payload: artists,
                });
            });

            return unsubscribe; // Unsubscribe when needed
        } catch (error) {
            dispatch({
                type: FETCH_ARTISTS_FAILURE,
                payload: error.message,
            });
        }
    };
};



export const fetchArtist = (artistId) => {
    return (dispatch) => {
      dispatch({ type: FETCH_ARTIST });
  
      try {
        const artistRef = doc(db, "artists", artistId.toLowerCase());
  
        const unsubscribe = onSnapshot(artistRef, (docSnapshot) => {
          if (docSnapshot.exists()) {
            dispatch({
              type: FETCH_ARTIST_SUCCESS,
              payload: { id: docSnapshot.id, ...docSnapshot.data() },
            });
          } else {
            dispatch({
              type: FETCH_ARTIST_FAILURE,
              payload: "Artist not found",
            });
          }
        });
  
        return unsubscribe; // Cleanup function for real-time updates
      } catch (error) {
        dispatch({
          type: FETCH_ARTIST_FAILURE,
          payload: error.message,
        });
      }
    };
  };

export const deleteArtist = (artist) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_ARTIST });

        try {
            const artistRef = doc(db, "artists", artist.username.toLowerCase());
            const artistSnap = await getDoc(artistRef);

            if (!artistSnap.exists()) {
                message.warning("Artist not found!");
                dispatch({ type: DELETE_ARTIST_FAILURE, payload: "Artist not found" });
                return;
            }


            try {
                if (artist.personalPicUrl) {
                    dispatch(deletePictureFromStorage(artist.personalPicUrl));
                }
            } catch (error) {

            }

            await deleteDoc(artistRef);

            dispatch({
                type: DELETE_ARTIST_SUCCESS,
                payload: artist, // Send deleted artist's username
            });

            message.success("Artist deleted successfully!");
        } catch (error) {
            dispatch({
                type: DELETE_ARTIST_FAILURE,
                payload: error.message,
            });

            message.error("Failed to delete artist!");
        }
    };
};


export const deletePictureFromStorage = (imageUrl) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_PICTURE });

        try {
            if (!imageUrl) {
                message.warning("No image URL provided!");
                dispatch({ type: DELETE_PICTURE_FAILURE, payload: "No image URL provided" });
                return;
            }

            const imageRef = ref(storage, imageUrl);

            await deleteObject(imageRef);

            dispatch({
                type: DELETE_PICTURE_SUCCESS,
                payload: imageUrl, // Send deleted image URL
            });

            message.success("Picture deleted successfully!");
        } catch (error) {
            dispatch({
                type: DELETE_PICTURE_FAILURE,
                payload: error.message,
            });

            message.error("Failed to delete picture!");
        }
    };
};
